import EasetechSpinner, { EasetechSpinnerProps } from "@/components/easetech-spinner/EasetechSpinner"
import { Row } from "antd"
import { FC } from "react"

const LoadingNotice: FC<EasetechSpinnerProps> = ({ content, isFormDivide }) => {
  return (
    <Row justify={"center"} align={"middle"}>
      <EasetechSpinner content={content} isFormDivide={isFormDivide} />
    </Row>
  )
}

export default LoadingNotice
